import React from "react";
import { Link } from "react-router-dom";
import MultiStepSignupForm from "@/components/auth/MultiStepSignupForm";

const MultiStepSignupDemo: React.FC = () => {
  return (
    <div className="min-h-screen bg-sauna-beige">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-sauna-navy mb-4">
            Multi-Step Signup Form Demo
          </h1>
          <p className="text-sauna-navy/80 max-w-2xl mx-auto">
            This is a demonstration of the new multi-step signup flow. The form is broken down into 3 steps:
            Account Creation, Personal Information, and Location & Review. Each step validates the data before
            allowing progression to the next step.
          </p>
          <div className="mt-4">
            <Link 
              to="/" 
              className="text-sauna-orange hover:underline font-medium"
            >
              ← Back to Home
            </Link>
          </div>
        </div>
        
        <MultiStepSignupForm />
      </div>
    </div>
  );
};

export default MultiStepSignupDemo; 